import { stringify } from '@angular/compiler/src/util';
import { Directive, ElementRef, Optional, HostListener, ViewContainerRef, Input } from '@angular/core';
import { NgControl, NgModel, ControlContainer } from '@angular/forms'
import { ValidatorLogic } from './validator-logic';

@Directive({
  selector: '[ngxValidator]'
})
export class NGXFormValidator {


  constructor(private controlContainer: ControlContainer,public ValidatorLogic: ValidatorLogic,private ele:ElementRef) {


  this.SetMutationOserver();

  }
  ngOnInit() {

 }



 private SetMutationOserver(){

  if(!this.ele){ return; }
  let observer = new MutationObserver((mutations)=>{

      let buttons = this.GetSubmitButtons();
      if(buttons && buttons.length>0){
        buttons.forEach(button=>{

          this.OnSubmitBtnClick(button);
        })
      }

  });
  observer.observe(this.ele.nativeElement,{childList:true,subtree:true,attributes:true})
}

private GetSubmitButtons():any[]{

  if(!this.ele){ return ;}

  let submitButtons = this.ele.nativeElement.querySelectorAll("button[type=submit]");

  return submitButtons;
}

private OnSubmitBtnClick(btnRef){

   btnRef.removeEventListener('click',this.btnClickHandler)

   btnRef.addEventListener('click',this.btnClickHandler)

}

public btnClickHandler =(event:any)=>{

  event.preventDefault();
  this.CallValidation(event.target)
}

private CallValidation(target){

  this.ValidatorLogic.formControl = this.controlContainer
  if(!this.ValidatorLogic.ValidateControls(null)){
    target.removeEventListener('click',this.btnClickHandler)
    target.click();
  }

}








  @HostListener("change", ["$event"]) change(event) {

    this.ValidatorLogic.formControl = this.controlContainer;
    if (event.srcElement.attributes.formcontrolname) {
      this.ValidatorLogic.ValidateControls(event.srcElement);
    }
  }

  @HostListener("submit", ["$event"]) submit(e) {
    //e.currentTarget.stopPropagation();

    //this.ValidatorLogic.formControl = this.controlContainer

   // this.ValidatorLogic.ValidateControls(null);
   // e.target.onSubmit=null;
    return false;
  }

  @HostListener('document:keydown.shift.f8',['$event']) openPanel(){

    this.ValidatorLogic.formControl = this.controlContainer
    this.ValidatorLogic.TogglePanel();

  }

}







@Directive({
  selector: '[ngModel], [formControl], [formControlName]', // or 'input, select, textarea' - but then your controls won't be handled and also checking for undefined would be necessary
})
export class NativeElementInjectorDirective {
  constructor(private el: ElementRef, private control: NgControl, @Optional() private model: NgModel) {
    this.appendNativeElement();

  }

  @Input('validationContainerId') validationContainerId:string;


  @HostListener('change', ['$event']) onChange(event) {
    this.appendNativeElement();

  }

  ngAfterViewInit() {

    this.appendNativeElement();
  }

  private appendNativeElement() {
    if (!!this.model)
      (<any>this.model.control).nativeElement = this.el.nativeElement;
    else if(this.control.control)
      (<any>this.control.control).nativeElement = this.el.nativeElement;


  }
}
